import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { FeatureServicesContext } from '../../use-feature-services';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';

export const GolfFormLoader = ({ onClose }: { onClose: () => void }) => {
  const featureServices = React.useContext(FeatureServicesContext);

  const featureAppService = featureServices?.['featureapp-service'] as FeatureappServiceV1;

  const [showOneForm, setShowOneForm] = React.useState<boolean>(false);
  const featureAppRef = React.useRef<any>(null);

  React.useEffect(() => {
    if (!showOneForm) {
      setShowOneForm(true);
    }
  }, [showOneForm]);

  React.useEffect(() => {
    const featureApp = featureAppService?.featureAppConfigurations['es-oneform-prospect-embedded'];
    featureAppRef.current = featureApp;
  }, [showOneForm, featureAppService]);

  const renderOneForm = () => (
    <FeatureAppLoader
      {...featureAppRef.current}
      featureAppId={`${featureAppRef.current.name}:oneform`}
      done={() => {
        setShowOneForm(false);
        onClose();
      }}
      beforeCreate={(env) => {
        if (env.featureServices['fa-content-service']) {
          env.featureServices['fa-content-service'].content = {
            featureApp: 'es-gti-50',
            dpsFields: [
              {
                field: 'headers[FORM_WEB_SECTION]',
                value: 'Golf GTI 50 Aniversario',
              },
              {
                field: 'fields[VEH_INTEREST_ID]',
                value: '30602',
              },
              {
                field: 'fields[VEH_INTEREST_MODEL]',
                value: 'Golf',
              },
              {
                field: 'fields[VEH_INTEREST_SALESGROUP]',
                value: 'Golf GTI',
              },
              {
                field: 'fields[VEH_INTEREST_SALESGROUP_ID]',
                value: '35272',
              },
              /*
              {
                field: 'fields[VEH_INTEREST_TRIM_LINE]',
                value: 'GTI',
              },
              {
                field: 'fields[VEH_INTEREST_DETAILS]',
                value: 'Edición 50 Aniversario',
              },
              */
            ],
          };
        }
        if (env.featureServices['api-key-provider']) {
          env.featureServices['api-key-provider'].apiKey = featureAppRef.current.apiKey;
        }
      }}
    />
  );

  return <>{showOneForm && featureAppRef.current ? renderOneForm() : null}</>;
};
